import { PropsWithChildren } from 'react';

import {
  OrderProvider,
  OrderProviderProps,
} from 'modules/order/common/providers/OrderProvider';

interface CreateOrderProviderProps extends OrderProviderProps {}

export const CreateOrderProvider = ({
  children,
  ...props
}: CreateOrderProviderProps & PropsWithChildren) => (
  <OrderProvider {...props}>{children}</OrderProvider>
);
